import styled from 'styled-components';

import { Button } from '@xingternal/button';
import { mediaConfined } from '@xingternal/layout-tokens';
import { spaceL, spaceS } from '@xingternal/tokens';

export const ActionsComponentContainer = styled.div<{ $isSticky: boolean }>`
  display: flex;
  margin-block: ${({ $isSticky }) => ($isSticky ? spaceL : null)};

  > *:not(:first-child) {
    margin-left: ${spaceS};
  }
`;

export const StyledSearchAlertButton = styled(Button)<{ $isSticky: boolean }>`
  @media ${mediaConfined} {
    width: ${({ $isSticky }) => (!$isSticky ? '50%' : null)};
  }
`;

export const StyledApplyAction = styled(Button)<{ $isSticky: boolean }>`
  width: 100%;

  @media ${mediaConfined} {
    width: ${({ $isSticky }) => (!$isSticky ? '50%' : null)};
  }
`;
